import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";

@Component({
  selector: 'app-paginated-table',
  templateUrl: 'paginated-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatedTableComponent<T = object> {
  @Input() collection: T[];
  @Input() perPage = 10;
  @Input() nextPage: any;
  @Input() prevPage: any;
  @Input() currentPage: number;
  @Input() lastPage: number;
  @Input() totalRows: number;
  @Input() itemsTo: number;
  @Input() itemsFrom: number;
  @Input() isLoading: boolean;
  @Input() yolo: boolean;

  @Output() pageInput = new EventEmitter<number>();

  form = new FormGroup({
    pageInput: new FormControl(1),
  });

  ngOnInit() {
    if (!this.yolo) {
      this.currentPage = 1;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('currentPage' in changes) {
      this.form.patchValue({ pageInput: changes.currentPage.currentValue });
    }
  }

  get items() {
    if (! this.collection) {
      return [];
    }

    // If we're using the new functionality, just return the collection
    if (this.yolo) {
      return this.collection;
    }

    return this.collection.slice(
      (this.currentPage - 1) * this.perPage,
      this.currentPage * this.perPage,
    );
  }

  // New functionality methods

  get itemsIndicator() {
    if (this.totalRows > 0) {
      return `${this.itemsFrom} - ${this.itemsTo} of ${this.totalRows}`;
    }
    return '0 of 0';
  }

  get isYoloFirstPage() {
    return this.currentPage === 1;
  }

  get isYoloLastPage() {
    return this.currentPage === this.lastPage;
  }

  // Old functionality methods | @TODO This should only be removed if EVERY component is using the new paginator functionality

  get total() {
    return this.collection.length;
  }

  get totalPages() {
    return Math.ceil(this.collection.length / this.perPage) || 1;
  }

  get isFirstPage() {
    return this.currentPage === 1;
  }

  get isLastPage() {
    return this.currentPage === this.totalPages;
  }

  previous() {
    if (! this.isFirstPage) {
      this.currentPage --;
    }
  }

  next() {
    if (! this.isLastPage) {
      this.currentPage ++;
    }
  }

  submit() {
    const page = parseInt(this.form.value.pageInput, 10);
    if (page >= 1 && page <= this.lastPage) {
      this.currentPage = page;
      this.pageInput.emit(page);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pagination/paginated-table.component.ts